/* Copyright 2013 - 2022 Waiterio LLC */
/** @jsx jsx */
import React, { useEffect, useState } from 'react'
import { css, jsx } from '@emotion/react'
import { useParams } from 'react-router-dom'
import useClient from '@authrice/react/useClient.js'
import card from '@stiloso/styles/card.js'
import label from '@stiloso/styles/label.js'
import input from '@stiloso/styles/input.js'
import section from '@stiloso/styles/section.js'
import sectionTitle from '@stiloso/styles/sectionTitle.js'
import { useTranslation } from '@multilocale/react/index.js'
import slugify from '@monorepo/shared/slugify.js'
import Button from '@stiloso/components/Button.js'
import LoadingDialog from '@stiloso/components/LoadingDialog.js'
import Layout from '../components/Layout.js'
import getRoles from '../session/getRoles.js'
import useLoggedInSession from '../session/useLoggedInSession.js'

export const paths = ['/clients/:clientName']

const ClientPage = () => {
  useLoggedInSession()
  // const navigate = useNavigate()
  const { clientName } = useParams()
  const { t } = useTranslation()
  const { data: client } = useClient(clientName)

  const [loadingProgress, setLoadingProgress] = useState('')
  const [error, setError] = useState(null)
  const [isClientEdited, setIsClientEdited] = useState(false)
  const [addLanguageDialog, setAddLanguageDialog] = useState(false)
  let [name, setName] = useState('')

  const canEditClient = !!getRoles().filter(
    ({ type }) => type === 'admin' || type === 'editor' || type === 'developer',
  ).length

  const changeName = event => {
    let name = event.target.value
    name = slugify(name)

    setName(name)
    setIsClientEdited(true)
  }

  const saveClient = event => {
    event.preventDefault()

    if (isClientEdited) {
      // mutation.mutate({
      //   ...client,
      //   name,
      //   customDomain,
      //   googleAnalyticsMeasurementId,
      //   lastEditTime: new Date().getTime(),
      // })

      setIsClientEdited(false)
    }
  }

  useEffect(() => {
    if (client) {
      setName(client.name)
    }
  }, [client])

  return (
    <Layout>
      <div css={section}>
        <div css={sectionTitle}>{t('Client')}</div>
        {client && (
          <>
            <div css={card}>
              <form onSubmit={saveClient} disabled>
                <div>
                  <label htmlFor="name" css={label}>
                    {t('name')}
                  </label>
                  <input
                    id="name"
                    css={input}
                    value={name}
                    onChange={changeName}
                    required
                    minLength="1"
                    autoFocus
                    autoComplete="off"
                    data-lpignore="true"
                    data-form-type="other"
                  />
                </div>

                <div>
                  <div css={label}>{t('Id')}</div>
                  <input css={input} value={client._id} readOnly />
                </div>

                {canEditClient && (
                  <Button type="submit">{t('Save client')}</Button>
                )}
              </form>
              {/* {mutation.isError && (
              <div css={{ color: 'red', marginTop: 16 }}>
                {mutation.error.message}
              </div>
            )} */}
            </div>
          </>
        )}
      </div>
      {loadingProgress && (
        <LoadingDialog title={t('Please wait')} message={loadingProgress} />
      )}
      {error && (
        <div css={section}>
          <p css={{ color: 'red' }}>{error}</p>
        </div>
      )}
    </Layout>
  )
}

export default ClientPage
